import { render, staticRenderFns } from "./swVentureStages.vue?vue&type=template&id=7c895f1b&scoped=true"
import script from "./swVentureStages.vue?vue&type=script&lang=js"
export * from "./swVentureStages.vue?vue&type=script&lang=js"
import style0 from "./swVentureStages.vue?vue&type=style&index=0&id=7c895f1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c895f1b",
  null
  
)

export default component.exports